import Config from "../config";
export default async function fetchProducts(){
    //let res = await fetch(`${Config.api_url}/stripe/products`);
    let res = await fetch(`${Config.api_url}/get-products`);
    const jsonData = await res.json();
    return jsonData;
}